import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import FreeOnlineTools from "../../Assets/Projects/FreeOnlineTools.png";
import divineBanner from "../../Assets/Projects/divineBanner.webp";
import BrahmaKart from "../../Assets/Projects/BrahmaKart.jpg";
import xomaaj from "../../Assets/Projects/Xomaaj.png";
import rhinomark from "../../Assets/Projects/rhinomark.png";
import DataForge from "../../Assets/Projects/DataForge.png";
import HypeCloud from "../../Assets/Projects/HypeCloud.png";
import Pawtern from "../../Assets/Projects/Pawtern.webp";
import QuickBioGen from "../../Assets/Projects/QuickBioGen.png";
import ToolMinty from "../../Assets/Projects/ToolMinty.png";
import NobleStitchHouse from "../../Assets/Projects/NobleStitchHouse.png";
import HennaHeaven from "../../Assets/Projects/HennaHeaven.png";
import InstaDownloader from "../../Assets/Projects/InstaDownloader.png";
import WavBit from "../../Assets/Projects/WavBit.png";
import { Helmet } from "react-helmet";

function Projects() {
  return (
    <>
      <Helmet>
        <title>Projects | Iftikhar Hussain | SpidyCoder</title>
        <meta
          name="description"
          content="Self-taught developer creating professional, modern websites and apps with a passion for learning and growth."
        />
        <link
          rel="canonical"
          href="https://iftikhariscoding.netlify.app/projects"
        />
      </Helmet>
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <h1 className="project-heading">
            My Recent <strong className="purple">Works ( 14 ) </strong>
          </h1>
          <p style={{ color: "white" }}>
            Here are the few projects I've worked on recently.
          </p>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            {/* WavBit */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={WavBit}
                isBlog={false}
                title={<span style={{ fontWeight: "bold" }}>WavBit 🎙️</span>}
                shortDescription="Next-generation experimental web application to transfer data seamlessly between devices using entirely acoustic channels..."
                description={
                  <>
                    WavBit is an innovative, experimental web application
                    designed to transfer data seamlessly between nearby devices
                    using entirely acoustic channels—no internet, Bluetooth, or
                    NFC required. By leveraging device speakers and microphones,
                    WavBit broadcasts short encoded payloads through precise
                    audio frequencies. 🔊
                    <br /> <br />
                    🎙️ <strong>What’s Inside?</strong>
                    <br />➤ <strong>Acoustic Data Transmission:</strong>{" "}
                    Securely broadcast and receive payloads without traditional
                    network connectivity.
                    <br />➤ <strong>
                      AI-Powered Semantic Compression:
                    </strong>{" "}
                    Integrates Gemini API to heavily compress natural language
                    strings.
                    <br />➤ <strong>Real-time Acoustic Decoding:</strong>{" "}
                    Passively listens for frequency markers and instantly
                    decodes audio streams into text.
                    <br /> <br />
                    🚀 Bleeding edge of offline, secure proximity communication.
                  </>
                }
                demoLink="https://wavbit.vercel.app"
              />
            </Col>

            {/* 1. Noble Stitch House */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={NobleStitchHouse}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>
                    Noble Stitch House 🧵
                  </span>
                }
                shortDescription="Your premier destination for custom bouquets, curated gifting, and elevated apparel..."
                description={
                  <>
                    Noble Stitch House is your premier destination for artisanal
                    florals, curated gifting, and elevated apparel. A digital
                    showcase combining bespoke tailoring with elegant gifts and
                    bouquets. 💐👗
                    <br /> <br />
                    🧵 <strong>What’s Inside?</strong>
                    <br />➤ <strong>Artisanal Florals:</strong> Order custom,
                    beautifully arranged flower bouquets.
                    <br />➤ <strong>Curated Gifting:</strong> Unique and
                    personalized gift sets for any occasion.
                    <br />➤ <strong>Elevated Apparel:</strong> Discover premium
                    fabrics and tailored clothing services.
                    <br />➤ <strong>Seamless Experience:</strong> A smooth,
                    elegant e-commerce platform for effortless browsing.
                    <br /> <br />
                    🚀 Where premium tailoring meets flawless floral gifting.
                  </>
                }
                demoLink="https://noble-stitch-house.web.app/"
              />
            </Col>

            {/* 2. Pawtern */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={Pawtern}
                isBlog={false}
                title={<span style={{ fontWeight: "bold" }}>Pawtern 🐾</span>}
                shortDescription="A fun and engaging free logic puzzle game where you find hidden cats..."
                description={
                  <>
                    Pawtern is a fun, engaging, and free logic puzzle game. Put
                    your observation skills to the test and find the hidden cats
                    in beautifully crafted puzzle patterns! 🧩🐈
                    <br /> <br />
                    🐾 <strong>What’s Inside?</strong>
                    <br />➤ <strong>Brain-Teasing Puzzles:</strong> Progress
                    through increasingly difficult logic challenges.
                    <br />➤ <strong>Hidden Cats:</strong> Discover adorable cats
                    hidden perfectly inside complex patterns.
                    <br />➤ <strong>Relaxing Gameplay:</strong> Casual mechanics
                    designed for all ages to enjoy.
                    <br />➤ <strong>Mobile Ready:</strong> Available as a fully
                    functional app for on-the-go gaming.
                    <br /> <br />✨ Test your logic and find the feline!
                  </>
                }
                demoLink="https://pawterium.web.app/"
              />
            </Col>

            {/* 3. Divine Love */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={divineBanner}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>Divine Love 💖</span>
                }
                shortDescription="An advanced, romantic relationship time tracker built with React Three Fiber, GSAP, and Firebase. Celebrate your love story with immersive 3D effects and real-time tracking..."
                description={
                  <>
                    Divine Love is the ultimate romantic time counter,
                    beautifully crafted for all lovebirds. Beyond just tracking
                    your relationship start date, it offers an immersive
                    experience powered by cutting-edge web technologies. 🕊️
                    <br /> <br />
                    💘 <strong>For Every Couple:</strong> Track your journey
                    down to the exact second.
                    <br />
                    🎨 <strong>Immersive 3D Experience:</strong> Built with
                    React Three Fiber and Three.js for stunning 3D visual
                    effects and heart animations.
                    <br />
                    💫 <strong>Smooth Animations:</strong> Powered by GSAP and
                    Framer Motion for a flawless, interactive UI.
                    <br />
                    📱 <strong>Modern Web Tech:</strong> React 19, Vite, and
                    Styled-Components ensure lightning-fast performance across
                    all devices.
                    <br />
                    ☁️ <strong>Secure & Offline-Ready:</strong> Integrated with
                    Firebase and IndexedDB for seamless data syncing and offline
                    capabilities.
                    <br />
                    📸 <strong>Customizable Memories:</strong> Includes custom
                    avatar uploads with client-side image compression and
                    screenshot generation (html2canvas).
                    <br /> <br />✨ Keep celebrating your moments
                    together—forever.
                  </>
                }
                demoLink="https://divinelovers.netlify.app/"
              />
            </Col>

            {/* 4. Xomaaj */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={xomaaj}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>
                    👥Xomaaj - Axomia Community💬
                  </span>
                }
                shortDescription="A modern Assamese hyperlocal community platform built for real connections, local discussions, chatting, vendors, and meaningful interaction..."
                description={
                  <>
                    A modern Assamese hyperlocal community platform built for
                    real connections, local discussions, chatting, vendors, and
                    meaningful interaction. No addictive reels or unnecessary
                    distractions—just a clean community-focused experience for
                    the new generation of Assam. 🚀 <br />
                    💬 **What’s Inside?** <br />➤ Real-time private chatting &
                    groups <br />➤ District based communities across Assam{" "}
                    <br />➤ Public/private text, image & link posts <br />➤
                    Vendor accounts for buying & selling products <br />➤
                    Verified profiles & trusted interactions <br />➤ Smooth
                    mobile-first modern UI experience <br />
                    Built with React, Vite & Firebase. Launching soon 🚀
                  </>
                }
                demoLink="https://xomaaj.web.app/"
              />
            </Col>

            {/* 5. RhinoMark */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={rhinomark}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>
                    RhinoMark - Premium Watermarking tool✒️🔏
                  </span>
                }
                shortDescription="A modern all-in-one watermarking platform designed for creators, developers, businesses, and social media users..."
                description={
                  <>
                    A modern all-in-one watermarking platform designed for
                    creators, developers, businesses, and social media users.
                    RhinoMark lets you protect, customize, and brand your images
                    with powerful watermarking tools through a clean and fast
                    modern interface. 🚀 <br />
                    🦏 **What’s Inside?** <br />➤ Custom text & logo
                    watermarking <br />➤ Batch image processing support <br />➤
                    Adjustable opacity, size & positioning <br />➤ Fast image
                    export with quality control <br />➤ Mobile-friendly smooth
                    UI experience <br />➤ Privacy-focused processing & modern
                    tools <br />
                    Built with modern web technologies for fast, secure, and
                    easy watermark creation anytime, anywhere. 🚀
                  </>
                }
                demoLink="https://rhinomark.vercel.app/"
              />
            </Col>

            {/* 6. BrahmaCart */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={BrahmaKart}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>BrahmaCart 🛒</span>
                }
                shortDescription="A powerful, user-friendly eCommerce platform designed to deliver fast, secure, and seamless online shopping with a complete ecosystem for buyers and sellers..."
                description={
                  <>
                    BrahmaCart is a powerful, user-friendly eCommerce platform
                    designed to deliver fast, secure, and seamless online
                    shopping. Built with modern technologies and optimized for
                    performance, BrahmaCart is not just another online store —
                    it’s a complete ecosystem for buyers, sellers, and admins.
                    <br />
                    <br />
                    ⚙️ <strong>Key Features:</strong>
                    <br />✅ <strong>Super Admin Panel:</strong> Full control
                    over users, products, orders, and site content. Manage
                    everything with ease from one powerful dashboard.
                    <br />✅ <strong>Admin Dashboard:</strong> Manage product
                    listings, prices, offers, and categories with real-time
                    updates.
                    <br />✅ <strong>Wishlist & Cart System:</strong> Users can
                    add products to their wishlist or cart, synced across
                    devices via Firestore.
                    <br />✅ <strong>
                      Real-Time Database (Firestore):
                    </strong>{" "}
                    Ultra-fast product updates, cart syncing, and user activity
                    tracking using Firebase Firestore.
                    <br />✅ <strong>Secure Authentication:</strong> Firebase
                    Auth for user login/registration with advanced security
                    layers to protect user data.
                    <br />✅ <strong>Mobile-First Responsive UI:</strong>{" "}
                    Beautiful and smooth user interface designed for mobile,
                    tablet, and desktop users.
                    <br />✅ <strong>Search & Filter System:</strong> Find what
                    you need instantly with smart search and product filtering.
                    <br />✅ <strong>Product Carousel & Banners:</strong>{" "}
                    Showcase collections, deals, and trending items with
                    stunning visuals.
                    <br />✅ <strong>Bottom Navigation Bar:</strong> Modern
                    app-style navigation for a smooth user experience.
                    <br />✅ <strong>Dark Mode Inspired Theme:</strong>{" "}
                    Eye-friendly dark theme with vibrant highlights and
                    glassmorphism effects.
                    <br /> <br />
                    Built to scale with Firebase backend, ensuring 99.9% uptime
                    and robust performance even under high traffic. 🚀
                  </>
                }
                demoLink="https://brahmakart.web.app/"
              />
            </Col>

            {/* 7. FreeOnlineTools */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={FreeOnlineTools}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>
                    100+ Free Online Tools 🛠️
                  </span>
                }
                shortDescription="A comprehensive suite of 100+ free online tools designed for developers, creators, and everyday users. Fast, secure, and privacy-focused..."
                description={
                  <>
                    A comprehensive suite of 100+ free online tools designed for
                    developers, creators, and everyday users. From SEO checkers
                    and password generators to image converters and JSON
                    formatters, this platform is your all-in-one toolkit for
                    digital productivity.
                    <br /> <br />
                    🚀 <strong>What’s Inside?</strong>
                    <br />➤ <strong>Developer Tools:</strong> JSON formatters,
                    Hash generators, base64 encoders.
                    <br />➤ <strong>SEO Utilities:</strong> Meta tag generators,
                    keyword density checkers, and sitemap creators.
                    <br />➤ <strong>Design & Media:</strong> Image compressors,
                    color pickers, and format converters.
                    <br />➤ <strong>Everyday Utilities:</strong> Unit
                    converters, strong password generators, and text tools.
                    <br />
                    <br />
                    🔒 <strong>Privacy First:</strong> Built with a focus on
                    security—many tools run completely locally in your browser
                    so your sensitive data never leaves your device!
                  </>
                }
                ghLink="#"
                demoLink="https://freeonlinetools.netlify.app/"
              />
            </Col>

            {/* 8. DataForge */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={DataForge}
                isBlog={false}
                title={<span style={{ fontWeight: "bold" }}>DataForge 🛠️</span>}
                shortDescription="A fast, privacy-first, free fake and random test data generator for developers..."
                description={
                  <>
                    DataForge is a fast, privacy-first, 100% free fake and test
                    data generator. Built specifically for developers, QA
                    engineers, and designers to easily populate their
                    applications with realistic data. 📊
                    <br /> <br />
                    ⚙️ <strong>Key Features:</strong>
                    <br />✅ <strong>Realistic Mock Data:</strong> Generate
                    names, addresses, emails, and more instantly.
                    <br />✅ <strong>Privacy-First:</strong> All data is
                    generated client-side with no tracking.
                    <br />✅ <strong>Export Capabilities:</strong> Download
                    generated data in JSON, CSV, or SQL formats.
                    <br />✅ <strong>Developer Friendly:</strong> Seamless
                    integration for testing and populating databases.
                    <br /> <br />✨ Forging test data has never been this robust
                    and intuitive.
                  </>
                }
                demoLink="https://dataforgepro.vercel.app/"
              />
            </Col>

            {/* 9. HypeCloud */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={HypeCloud}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>HypeCloud V2 ☁️</span>
                }
                shortDescription="Next-generation cloud storage and file management platform ensuring seamless storage and fast APIs..."
                description={
                  <>
                    HypeCloud V2 is the ultimate next-generation cloud
                    infrastructure platform. It provides seamless file storage,
                    blazing-fast APIs, and a highly scalable architecture
                    designed for modern teams and creators. 🌩️
                    <br /> <br />
                    ☁️ <strong>What’s Inside?</strong>
                    <br />➤ <strong>Secure Storage:</strong> End-to-end
                    encrypted file uploads and management.
                    <br />➤ <strong>Fast APIs:</strong> RESTful architecture
                    ensuring rapid data retrieval.
                    <br />➤ <strong>Seamless Sharing:</strong> Generate secure
                    links to share files instantly.
                    <br />➤ <strong>Modern Dashboard:</strong> A sleek,
                    glassmorphism-inspired UI for effortless navigation.
                    <br /> <br />
                    🚀 Take your digital assets to the next level with
                    HypeCloud.
                  </>
                }
                demoLink="#"
              />
            </Col>

            {/* 10. QuickBioGen */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={QuickBioGen}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>QuickBioGen 📄</span>
                }
                shortDescription="Instantly generate professional and beautiful bio-data for various purposes with just a few clicks..."
                description={
                  <>
                    QuickBioGen is a lightning-fast utility designed to help you
                    instantly generate professional, aesthetic bio-data. Whether
                    for matrimony or professional use, build a stunning profile
                    in minutes. 🖋️
                    <br /> <br />
                    📄 <strong>What’s Inside?</strong>
                    <br />➤ <strong>Smart Templates:</strong> Choose from a
                    variety of elegant, pre-designed templates.
                    <br />➤ <strong>Instant PDF Export:</strong> Download your
                    finished bio-data in high-quality PDF format.
                    <br />➤ <strong>Live Preview:</strong> See your changes in
                    real-time as you type.
                    <br />➤ <strong>Privacy Focused:</strong> All data is
                    processed locally without storing your personal info on
                    servers.
                    <br /> <br />
                    🚀 Creating a beautiful impression is now just a few clicks
                    away.
                  </>
                }
                demoLink="https://quickbiogen.vercel.app/"
              />
            </Col>

            {/* 11. ToolMinty */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={ToolMinty}
                isBlog={false}
                title={<span style={{ fontWeight: "bold" }}>ToolMinty 🧰</span>}
                shortDescription="A refreshing collection of essential online utilities designed to maximize productivity and streamline workflows..."
                description={
                  <>
                    ToolMinty brings together a fresh, minty suite of highly
                    useful online tools. It is designed to maximize your
                    productivity and streamline your daily developer and
                    creative workflows in one place. 🍃
                    <br /> <br />
                    🧰 <strong>Key Features:</strong>
                    <br />✅ <strong>Developer Utilities:</strong> Formatters,
                    encoders, decoders, and code testers.
                    <br />✅ <strong>Image Tools:</strong> Compress, crop, and
                    convert images instantly.
                    <br />✅ <strong>Text Manipulators:</strong> Word counters,
                    case converters, and diff checkers.
                    <br />✅ <strong>Clean UI:</strong> A refreshing, ad-free
                    interface focusing purely on functionality.
                    <br /> <br />✨ Your pocket Swiss Army knife for the web.
                  </>
                }
                demoLink="https://toolminty.vercel.app/"
              />
            </Col>

            {/* 12. Henna Heaven */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={HennaHeaven}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>Henna Heaven 🌿</span>
                }
                shortDescription="Beautiful Mehndi and Henna designs showcase and bookings, providing a seamless way for customers to view art..."
                description={
                  <>
                    Henna Heaven offers a beautiful, interactive gallery of
                    breathtaking Mehndi designs. It provides a seamless way for
                    customers to view intricate art and easily book appointments
                    with artists. 🌸
                    <br /> <br />
                    🌿 <strong>Key Features:</strong>
                    <br />✅ <strong>Interactive Gallery:</strong>{" "}
                    High-resolution showcase of bridal and casual Mehndi
                    designs.
                    <br />✅ <strong>Booking System:</strong> Select dates,
                    styles, and seamlessly reserve appointments.
                    <br />✅ <strong>Artist Portfolios:</strong> Get to know the
                    artists and view their specific design specialties.
                    <br />✅ <strong>Responsive Design:</strong> Looks stunning
                    whether browsing on mobile or desktop.
                    <br /> <br />✨ Bringing the timeless art of Henna to your
                    fingertips.
                  </>
                }
                // demoLink="#"
              />
            </Col>

            {/* 13. IG Video Downloader */}
            <Col md={6} lg={4} className="project-card">
              <ProjectCard
                imgPath={InstaDownloader}
                isBlog={false}
                title={
                  <span style={{ fontWeight: "bold" }}>
                    IG Video Downloader 📹
                  </span>
                }
                shortDescription="A lightweight PHP script that extracts and downloads Instagram videos reliably..."
                description={
                  <>
                    A fast, lightweight, and highly efficient PHP script
                    engineered to extract and download Instagram videos
                    reliably. It provides a seamless backend utility for
                    developers looking to integrate social media media fetching.
                    🚀
                    <br /> <br />
                    📹 <strong>What’s Inside?</strong>
                    <br />➤ <strong>Fast Extraction:</strong> Rapidly parses
                    Instagram URLs to fetch direct video links.
                    <br />➤ <strong>Lightweight Backend:</strong> Pure PHP
                    script with minimal dependencies.
                    <br />➤ <strong>High Quality:</strong> Fetches the highest
                    resolution video available on the platform.
                    <br />➤ <strong>Developer Friendly:</strong> Easy to
                    integrate into existing web applications or bots.
                    <br /> <br />
                    ⚙️ A reliable utility script powering seamless media
                    downloads.
                  </>
                }
                // demoLink="#"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Projects;
